import type { MandatoryLabelModalProps } from './components/CLPMandatoryLabelModal';
import type { CLPSubjectHeaderLabelProps } from './components/CLPSubjectHeaderLabel';
import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyAction,
    type LazyComponent,
    LazyImport,
    LazyModule,
} from 'owa-bundling';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "Protection"*/ './lazyIndex'),
    {
        name: 'Protection',
    }
);

export const lazyLoadCLPUserLabels: LazyAction<
    typeof lazyIndex.loadCLPUserLabels,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadCLPUserLabels);
export const lazyGetPendingLoadLabelPromise: LazyAction<
    typeof lazyIndex.getPendingLoadLabelPromise,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.getPendingLoadLabelPromise);
export const lazyShowJustificationModal: LazyAction<
    typeof lazyIndex.showJustificationModal,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.showJustificationModal);
export const lazyLoadItemCLPInfo: LazyAction<
    typeof lazyIndex.loadItemCLPInfo,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadItemCLPInfo);
export const lazyUpdateItemCLPInfo: LazyImport<
    typeof lazyIndex.updateItemCLPInfo,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.updateItemCLPInfo);
export const lazyLogReadCLPLabel: LazyImport<
    typeof lazyIndex.logReadCLPLabel,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.logReadCLPLabel);
export const lazyLogCLPLabelChange: LazyAction<
    typeof lazyIndex.logCLPLabelChange,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.logCLPLabelChange);
export const lazyShouldShowLouderLabelsMenu: LazyImport<
    typeof lazyIndex.shouldShowLouderLabelsMenu,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.shouldShowLouderLabelsMenu);
export const lazyLoadComplianceConfig: LazyAction<
    typeof lazyIndex.loadComplianceConfig,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadComplianceConfig);
export const CLPSubjectHeaderLabel: LazyComponent<CLPSubjectHeaderLabelProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CLPSubjectHeaderLabel);
export const lazyGetCLPLableFromItem: LazyAction<
    typeof lazyIndex.getCLPLableFromItem,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.getCLPLableFromItem);
export const CLPMandatoryLabelModal: LazyComponent<MandatoryLabelModalProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CLPMandatoryLabelModal);
export const lazyLoadDLPPolicies: LazyAction<
    typeof lazyIndex.loadDLPPolicies,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadDLPPolicies);
export const lazyLoadDLPPoliciesForSecondaryAccounts: LazyAction<
    typeof lazyIndex.loadDLPPoliciesForSecondaryAccounts,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadDLPPoliciesForSecondaryAccounts);
export const lazyHandleAutoLabelingResult: LazyAction<
    typeof lazyIndex.handleAutoLabelingResult,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.handleAutoLabelingResult);
export const lazyClearCLPLabel: LazyAction<
    typeof lazyIndex.clearCLPLabel,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.clearCLPLabel);
export const lazyGetAttachmentLabels: LazyAction<
    typeof lazyIndex.getAttachmentLabels,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.getAttachmentLabels);
export const lazyClearAttachmentLabelsCache: LazyAction<
    typeof lazyIndex.clearAttachmentLabelsCache,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.clearAttachmentLabelsCache);
export const lazyTriggerAttachmentLabelInheritance: LazyAction<
    typeof lazyIndex.triggerAttachmentLabelInheritance,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.triggerAttachmentLabelInheritance);

export { getCLPLabel } from './selectors/getCLPLabel';
